import { apiVoissa } from "../../libs/api";

// Plans d'abonnement (Voissa Plus / Voissa Max) + activation de l'essai gratuit.
// Backend : GET /plans, POST /users/me/trial. Voir SPEC-TRIAL-ABONNEMENTS-v2.md §8.
export const fetchPlans = (config = {}) => apiVoissa.get(`/plans`, config);

// Offres (Plus + Premium) avec prix de l'utilisateur (source : vMessenger) + avantages.
// Backend : GET /plans/offers → { status, plus:{label,advantages,offers[]}, premium:{...} }.
export const fetchPlansOffers = (config = {}) => apiVoissa.get(`/plans/offers`, config);

// Active l'essai gratuit d'un plan (slug). Renvoie le subscription réactualisé.
export const startTrial = (slug, config = {}) => apiVoissa.post(`/users/me/trial`, { slug }, config);

// Marque une modale trial comme vue (persistance serveur, cross-navigateur).
// prompt = 'trialOffer' (modale 1) | 'trialEnded' (modale 3).
export const markTrialPromptSeen = (prompt, config = {}) => apiVoissa.post(`/users/me/trial-prompts/seen`, { prompt }, config);

export const PLANS_KEY = `plans`;
